import React from 'react';
/* eslint-disable */

export default props => (
<svg height={20} width={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" >
    <path d="m6.5 7.5h4l-6 9v-6.997l-4-.003 6-9z" fill="none" stroke-linecap="round" stroke-width="1.5" stroke-linejoin="round" transform="translate(5 2)"></path>
</svg>

)

/* eslint-enable */
